import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue';
import App from '@/App';
import router from '@/router';
import store from '@/config/store';
import '@/registerServiceWorker';

Vue.config.productionTip = false;

// require('@/setup/components');
require('@/config/plugins');
require('@/config/vuetify');

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
